import React from 'react';
import { motion } from 'framer-motion';
import { 
  Award, 
  Rocket, 
  Users,
  Target,
  Lightbulb,
  Heart,
  Shield,
  LineChart
} from 'lucide-react';
import { cn } from '../../lib/utils';
import AboutHero from './sections/AboutHero';
import VisionMission from './sections/VisionMission';
import WhyChooseUs from './sections/WhyChooseUs';
import OurStory from './sections/OurStory';
import OurCommitments from './sections/OurCommitments';
import OurImpact from './sections/OurImpact';
import CallToAction from './sections/CallToAction';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <AboutHero />
      <VisionMission />
      <WhyChooseUs />
      <OurStory />
      <OurCommitments />
      <OurImpact />
      <CallToAction />
    </div>
  );
};

export default AboutPage;